export enum AgreementType {
  USER_EULA = 'User Agreement',
  OPERATOR_EULA = 'Operator Agreement',
  CVP = 'Charter Vendor Program Agreement'
}
